import { createApp } from 'vue';
import { createPinia } from 'pinia';
import TDesign from 'tdesign-vue-next';
import 'tdesign-vue-next/es/style/index.css';
// Note: @umoteam/editor is loaded dynamically in DocumentCreatorView to avoid pdfjs-dist version conflict
import App from './App.vue';
import router from './router';
import './assets/styles/main.css';
import { initFileUrl } from './composables/useFileUrl';

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(TDesign);

// Load file URL config (CDN vs local) before mounting
initFileUrl().finally(() => {
  app.mount('#app');
});
